import { useQuery } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import { useAuth } from 'react-oidc-context';

import api from 'api/api';
import { Access } from 'hooks/data/files/types';

const fetchAccess = async () => {
  const { data } = await api.get(`/web/access`);

  return data;
};

const useAccess = () => {
  const { isAuthenticated } = useAuth();

  return useQuery<Access, AxiosError>({
    queryKey: ['access', isAuthenticated],
    queryFn: fetchAccess,
    enabled: !!isAuthenticated,
  });
};

export default useAccess;
